import { MDBBtn, MDBDatatable, MDBIcon, MDBInput, MDBInputGroup, MDBSpinner } from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import {
  getMisc,
  getUsersAndTeamAdmin,
  updateUsersAndTeamsAdmin,
} from "../../../apiclients/streamsapi_bridge";
import AddToUsersTeam from "../../../views/popups/misc/AddToUsersTeam";
import PopupLoader from "../../../views/popups/PopupLoader";
import AddUserFromAnotherAcc from "../../../views/popups/users/AddUserFromAnotherAcc";
import DeleteUserandTeamAdmin from "../../../views/popups/users/DeleteUserandTeamAdmin";
import SaveChanges from "../../topviews/saveCancel";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import TopSuccess from "../../header/TopSuccess";
import TopMessage from "../../header/TopMessage";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";

function UseranTeamAdmin(props) {
  const { t, i18n } = useTranslation();
  const [isloading, setIsLoading] = useState(false);
  const [teamMembers, setteamMembers] = useState([]);
  const [agentid, setagentid] = useState("");
  const toggleShow50 = () =>
    setAddUserFromAnotherAccount(!AddUserFromAnotherAccount);
  const [AddUserFromAnotherAccount, setAddUserFromAnotherAccount] =
    useState(false);
  const deleteToggle = () => setDeleteUserTeam(!deleteUserTeam);
  const [deleteUserTeam, setDeleteUserTeam] = useState(false);

  const [addUserTeam, setAddUserTeam] = useState(false);
  const addUserToggle = () => setAddUserTeam(!addUserTeam);
  const [sourceUsers, setSourceUsers] = useState([]);
  const [updateUsers, setUpdateUsers] = useState([]);
  const [isAddedUsers, setIsAddedUsers] = useState(false);
  const addUserRef = useRef(null);
  const [isLoading, setisLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [teamid, setTeamid] = useState("");
  const [reRender, setreRender] = useState(false);
  const [searchValue, setSearchValue] = useState(""); 
  const [filteredIndices, setFilteredIndices] = useState([]); 
 
  const [dataLoaded, setDataLoaded] = useState(false);
  const searchRef = useRef(null);
  useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,props.isActive)


  useEffect(() => {
    if (successMessage) {
      setTimeout(() => {
        setSuccessMessage(""); // Clear the success message in the parent component
      }, 5000);
    }
  }, [successMessage]);

  function handleClick() {
    addUserRef.current.click();
  }

  const navigate = useNavigate();
  const {
    register,
    control,
    formState: { isDirty, dirtyFields, errors },
    setValue,
    watch,
    reset,
    handleSubmit,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      users_role_change: [],
    },
  });

  const { fields } = useFieldArray({
    control,
    name: "users_role_change",
  });

  useEffect(() => {
    setSearchValue(""); 
    if (fields && Array.isArray(fields) && fields.length > 0) {
      setFilteredIndices(fields.map((_, index) => index));
    } else {
      setFilteredIndices([]);
    }
  }, [fields.length]);


  useEffect(() => {
    if (props?.teamInfo?.team_id && props.isActive) {
      getUsersAnTeam();
      fetchTeamUser();
    }
  }, [props.teamInfo, props.isActive]);

  const handleDelete = (memObj) => {
    // console.log(`deleting ${JSON.stringify(memObj)}`);
    setagentid(memObj.agentId);
    deleteToggle();
  };

  // useEffect(() => { 
  let proccessdRows = [];
    if (fields && fields.length > 0 && filteredIndices.length > 0) {

        filteredIndices.forEach((originalIndex) => {
          const member = fields[originalIndex];
          
          // Additional safety check for the individual field object
          if (!member || typeof member !== 'object') return;       
    proccessdRows.push({
      member: member,
      user: member?.username ?? "",
      email: member?.emailId ?? "",
      role: member?.role ?? "",
      admin: (
        <>
          <label className="switch" onClick={(e) => e.stopPropagation()}>
            <input
              className="form-control"
              type="checkbox"
              id="AllowUsersCallerID"
              checked={watch(`users_role_change.${originalIndex}.isadmin`)}
              name="manage_cid"
              onChange={(e) => {
                clearErrors("users_role_change");
                setValue(
                  `users_role_change.${originalIndex}.isadmin`,
                  e.target.checked,
                  { shouldDirty: true }
                );
                setValue(`users_role_change.${originalIndex}.userid`, member.agentId, {
                  shouldDirty: true,
                });
              }}
            />
            <span className="slider round"></span>
          </label>
        </>
      ),
      remove: (
        <>
          <div className="d-flex">
            <div
              className="custom-hover-bg ms-3 p-1 cursor-pointer deleteToolTip"
              onClick={(e) => {
                e.preventDefault();
                handleDelete(member);
              }}
            >
              <MDBIcon className="fs-5" far icon="trash-alt" color="primary" />
            </div>
          </div>
        </>
      ),
    });
  });
}
  // setRowData(proccessdRows);
  // setFilteredRows(proccessdRows)
// },[fields])

  const actionData = {
    columns: [
      { label: "User", field: "user" },
      { label: "Email", field: "email" },
      { label: "Role", field: "role" },
      { label: "Admin", field: "admin" },
      { label: "Remove", field: "remove", sort: false },
    ],
    rows: proccessdRows,
  };

  async function getUsersAnTeam() {
    try {
      let siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      //  alert(teamid);
      setIsLoading(true);
      const serverResponsedata = await getUsersAndTeamAdmin(
        siteid,
        props?.teamInfo?.team_id
      );

      setIsLoading(false);
      console.log(
        "resposne is ::::::::::::::: " + JSON.stringify(serverResponsedata)
      );
      console.log("resposne status ::::::::::::::: " + serverResponsedata.ok);
      // debugger;
      if (!serverResponsedata.ok) {
        console.log("Network response was not ok");
        throw new Error("Network response was not ok");
      } else {
        const data = await serverResponsedata.json();
        if (data.status == "success") {
          console.log("Team members info " + JSON.stringify(data));
          // let membersDetails = data?.team_members ?? [];
          // membersDetails = membersDetails.map((member) => ({
          //   ...member,
          //   isAdmin: member.role.indexOf("admin") != -1 ? true : false,
          // }));
          setteamMembers(data?.team_members ?? []);
          reset({
            users_role_change: data?.team_members ?? [],
          });
          setDataLoaded(true)  // Set data loaded after API call
        }
      }
      // setreRender(false);
    } catch (error) {
      console.error("[getUsersAnTeam] Error:", error);
      // Handle the error, show a user-friendly message or log it.
    }
  }

  async function fetchTeamUser() {
    let UserList = [],
      apiResponse = {};
    apiResponse = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { misc: ["team_members"], teamid: props?.teamInfo?.team_id }
    );

    if (apiResponse.status === 200) {
      UserList = await apiResponse.json();

      UserList = UserList?.misc?.team_members ?? [];
      console.log(`Team Free UserList ::::: ${JSON.stringify(UserList)}`);
      setSourceUsers(UserList);
    } else {
    }
  }

  useEffect(() => {
    if (updateUsers.length > 0 && isAddedUsers) {
      console.log("update User ::::::::::: " + JSON.stringify(updateUsers));
      const userInfo = updateUsers.map((user) => ({
        userid: user.agentId,
        isadmin: user.isAdmin ? user.isAdmin : false,
      }));
      sendUpdateAPIRequest("add_users", userInfo);
      setIsAddedUsers(false);
    }
  }, [updateUsers, isAddedUsers]);

  async function sendUpdateAPIRequest(keyName, userInfo) {
    try {
      const siteid = JSON.parse(sessionStorage.getItem("admin_session")).siteid;
      console.log(JSON.parse(sessionStorage.getItem("admin_session")).siteid);

      setIsLoading(true);
      let update = {
        reqid: 88,
        siteid: siteid,
        [keyName]: userInfo,
        teamid: props.teamInfo.team_id,
      };

      console.log(
        "reques for sendUpdateAPIRequest  :::: " + JSON.stringify(update)
      );
      let deleteFilter = await updateUsersAndTeamsAdmin(update);
      setTimeout(() => {
        setIsLoading(false);
      }, 1000);
      let deleteMsg = await deleteFilter.json();
      console.log("Response...  ::::::::: " + JSON.stringify(deleteMsg));
      // console.log(deleteMsg);
      if (deleteMsg.status == "success") {
        // props.setSuccessMessage(deleteMsg.message);
        localStorage.setItem("s_message", deleteMsg.message);
        // setTeamid(deleteMsg.teamid);
        // setreRender(true);
        const teamTempInfo = { ...props.teamInfo, team_id: deleteMsg.teamid };
        navigate("/selectedteamsettings", {
          state: { tab: "tab2", teamInfo: teamTempInfo },
        });

        window.location.reload();
      } else if (deleteMsg?.message?.errors?.length > 0) {
        deleteMsg.message.errors.forEach((err) => {
          setError(err.param_name, {
            type: "server",
            message: err.message,
          });
        });
      } else {
        localStorage.setItem("f_message", deleteMsg.message);
        const teamTempInfo = { ...props.teamInfo, team_id: deleteMsg.teamid };
        navigate("/selectedteamsettings", {
          state: { tab: "tab2", teamInfo: teamTempInfo },
        });

        window.location.reload();
      }
    } catch (error) {}
  }

  function closeSave(e) {
    reset();
  }

  const onSubmit = async (data) => {
    const modifiedListKey = dirtyFields.users_role_change;
    const modifiedListData = data.users_role_change;
    let modifiedField = [];
    modifiedListKey.forEach((field, index) => {
      if (field && field.isadmin !== undefined) {
        modifiedField.push({
          userid: modifiedListData[index].userid,
          isadmin: modifiedListData[index].isadmin,
        });
      }
    });
    console.log("modifiedField :::: " + JSON.stringify(modifiedField));
    sendUpdateAPIRequest("users_role_change", modifiedField);
  };

  const isSave = Object.keys(dirtyFields).length === 0 ? false : true;

  useEffect(() => {
    props.setEdited(isSave);
  }, [isSave]);

  
const handleSerach = (value) => {
  setSearchValue(value); // <--- add this

  // Safety check for fields array
  if (!fields || fields.length === 0) {
    setFilteredIndices([]);
    return;
  }
  
  if (!value.trim()) {
    // Show all items when search is cleared
    setFilteredIndices(fields.map((_, index) => index));
    return;
  }
  
  // Use your existing customSearch method
  const filterResult = customSearch(fields, value, UIConstant.USER_STREAMS_TEAMS);
  
  // Find indices of filtered results in original fields array
  const matchingIndices = filterResult.map(filteredItem => 
    fields.findIndex(field => 
      field && ( // Add safety check for field existence
        field.id === filteredItem.id || 
        (field.username === filteredItem.username && field.emailId === filteredItem.emailId  && field.role === filteredItem.role)
      )
    )
  ).filter(index => index !== -1);
  
  setFilteredIndices(matchingIndices);
};


  return (
    <>
      <div className="actionbar button_aligniment">
        <MDBBtn
          className=" btn-width-100 mt-sm-10  margin-end-10"
          onClick={addUserToggle}
        >
          <MDBIcon fas icon="plus" size="sm" /> {t("AddTeamUser")}
        </MDBBtn>
        {/* <MDBBtn className=" btn-width-100 mt-sm-10  margin-end-10">
          <MDBIcon fas icon="plus" size="sm" /> {t("AddTeamAdmin")}
        </MDBBtn> */}
        {props.teamType && props.teamType === "Public" && (
          <MDBBtn
            className=" btn-width-100 mt-sm-10  margin-end-10"
            onClick={toggleShow50}
          >
            <MDBIcon fas icon="plus" size="sm" /> {t("AdduseranotherAccount")}
          </MDBBtn>
        )}
      </div>
      {errors?.users_role_change && (
        <p className="text-danger">{errors?.users_role_change?.message}</p>
      )}        
         {teamMembers && (
        <div className='mb mt position-relative w-auto'>
        <MDBInput ref={searchRef} label="Search"  onChange={(e) => handleSerach(e.target.value)} />
        <MDBIcon fas icon="search" className='MDBDatatable-Search' />
      </div> 
       )}
      <MDBDatatable
        hover
        // serach
        key={searchValue}
        entries={50}
        data={
        actionData}
        sortField="User"
        maxHeight="63vh"
        className="maxheight63 actioncolumn"
      />

      {isSave && (
        <SaveChanges
          onClose={closeSave}
          isdirtyFields={isSave}
          onSave={(e) => {
            e.preventDefault();
            handleSubmit(onSubmit)();
          }}
        />
      )}

      {addUserTeam && (
        <PopupLoaderNew
          title="Add User"
          size="lg"
          content={
            <>
              <AddToUsersTeam
                selectedUsers={teamMembers}
                sourceUsers={sourceUsers}
                setUpdateUsers={setUpdateUsers}
                setIsAddedUsers={setIsAddedUsers}
                onClose={addUserToggle}
                ref={addUserRef}
                setIsloading={setisLoading}
              />
            </>
          }
          onShow={setAddUserTeam}
          onClose={addUserToggle}
          onSave={handleClick}
          isloading={isLoading}
          flag={1}
        />
      )}

      {AddUserFromAnotherAccount && (
        <PopupLoader
          title={t("AdduseranotherAccount")}
          content={
            <AddUserFromAnotherAcc
              teamInfo={props.teamInfo}
              onClose={toggleShow50}
              setSuccessMessage={props.setSuccessMessage}
            />
          }
          onShow={setAddUserFromAnotherAccount}
          onClose={toggleShow50}
        />
      )}

      {deleteUserTeam && (
        <PopupLoader
          title={t("Remove Team User")}
          content={
            <DeleteUserandTeamAdmin
              agentid={agentid}
              teamInfo={props.teamInfo}
              onClose={deleteToggle}
              setSuccessMessage={props.setSuccessMessage}
            />
          }
          onShow={setDeleteUserTeam}
          onClose={deleteToggle}
        />
      )}

      {isloading && (
        <>
          <div className="loadingclass">
            <MDBBtn disabled>
              <MDBSpinner size="sm" role="status" tag="span" className="me-2" />
              Loading...
            </MDBBtn>
          </div>
        </>
      )}
      {successMessage && (
        <>
          <TopSuccess>
            <TopMessage successMessage={successMessage} />
          </TopSuccess>
        </>
      )}
    </>
  );
}

export default UseranTeamAdmin;
